import { apiSlice } from "../../app/apiSlice";
import { withDefaultMeta } from "../../util/withDefaultMeta";

export const notificationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const query = withDefaultMeta(builder.query);
    const mutation = withDefaultMeta(builder.mutation);

    return {
      getUnreadNotifications: query({
        query: () => "/notifications/unread",
        providesTags: ["Notification"],
      }),
      markNotificationAsRead: mutation({
        query: (id) => ({
          url: `/notifications/${id}/read`,
          method: "PATCH",
        }),
        invalidatesTags: ["Notification"],
      }),
    };
  },
});

export const {
  useGetUnreadNotificationsQuery,
  useMarkNotificationAsReadMutation,
} = notificationApiSlice;
